import React from 'react';
import '../CSS/Profile/ChrisSchulerProfile.css';

const ChrisSchulerProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/chris-schuler-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Chris Schuler"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Chris Schuler</h1>
        <div className="profile-title-container">
          <p className="profile-title">Consultant</p>
          <a href="https://www.linkedin.com/in/christopherschuler/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Chris is a staunch brain cancer awareness advocate, motivated by his experience as the primary caregiver to his late father, Donald Schuler, who was diagnosed with GBM in July 2021. He works globally with organizations to amplify their work and build relationships to improve patient outcomes.
          </p>
          <p>
            His career has spanned almost two decades, involving philanthropic roles in various industries such as non-profit, public and private higher education, and healthcare.
          </p>
          <p>
            Currently, Chris is working with the Cure Brain Cancer Foundation, an Australian non-profit focused on improving brain cancer outcomes. He is also a Venture Partner with Varia Ventures, where he raises awareness for venture funds dedicated to discovering and funding innovations for brain health. Additionally, he works with SageMedic, a precision oncology start-up that supports patients seeking effective cancer treatments.
          </p>
          <p>
            For more information on his background, please visit his LinkedIn profile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChrisSchulerProfile;

